module.exports = __webpack_public_path__ + "img/banner.feda6a9d.png";